export default [
  {
    path: "permissionList",
    name: "permissionList",
    meta: {
      title: "权限列表"
    },
    component: resolve =>
      require(["@/views/permission/permissionList.vue"], resolve)
  },
  {
    path: "roleList",
    name: "roleList",
    meta: {
      title: "角色列表"
    },
    component: resolve => require(["@/views/role/roleList.vue"], resolve)
  },
  {
    path: "userRoleList",
    name: "userRoleList",
    meta: {
      title: "用户权限"
    },
    component: resolve =>
      require(["@/views/userRole/userRoleList.vue"], resolve)
  }
];
